import PageEmptyState from './PageEmptyState.component';

export default PageEmptyState;
